const GET_SUB_AZURE = 'GET_SUB_AZURE';
const GET_SUB_AZURE_SUCCESS = 'GET_AZURE_SUB_SUCCESS';
const GET_SUB_AZURE_ERROR = 'GET_AZURE_SUB_ERROR';
 
export {
  GET_SUB_AZURE, GET_SUB_AZURE_SUCCESS, GET_SUB_AZURE_ERROR
  
};
